import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faJs,
  faVuejs,
  faHtml5,
  faCss3Alt,
  faNodeJs,
  faGitAlt,
  faPhp,
  faAngular,
  faBootstrap,
  faLaravel,
  faJava,
  faLinkedin,
  faGithub,
  faTwitter,
  faAtlassian,
  faDocker,
  faFigma,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faCopy,
  faMoon,
  faLanguage,
  faLightbulb,
  faDatabase,
  faHome,
  faUser,
  faTools,
  faEye,
  faBriefcase,
  faTasks,
  faFontAwesome,
} from "@fortawesome/free-solid-svg-icons";

import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import es from "./locales/es.json";

library.add(
  faJs,
  faVuejs,
  faHtml5,
  faCss3Alt,
  faNodeJs,
  faGitAlt,
  faLightbulb,
  faEnvelope,
  faCopy,
  faLinkedin,
  faGithub,
  faTwitter,
  faPhp,
  faAngular,
  faBootstrap,
  faMoon,
  faLanguage,
  faLaravel,
  faJava,
  faDatabase,
  faHome,
  faUser,
  faTools,
  faAtlassian,
  faDocker,
  faEye,
  faBriefcase,
  faTasks,
  faFontAwesome,
  faFigma
);

const app = createApp(App);

const i18n = createI18n({
  legacy: false, // Usar la nueva API
  locale: "es", // Idioma por defecto
  messages: {
    en,
    es,
  },
});

app.use(store);
app.use(router);
app.use(i18n);
app.mount("#app");
app.component("font-awesome-icon", FontAwesomeIcon);
